<template>
  <div>
    <BillssMonitoring :titlee="'Lot Rental'">

    </BillssMonitoring>
  </div>
</template>
<script>
  import BillssMonitoring from './BillssMonitoring'

  export default {
    components: {
      BillssMonitoring,
    },
  }
</script>
